import {AxiosError} from 'axios';
import {CredentialType} from 'web-library/models/AccountManagementConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_UNLOCK_ACCOUNT_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";
import {Dayjs} from "dayjs";

export interface PostUnlockAccountFormData {
  accountType: CredentialType;
  username: string;
  dateOfBirth: string;
}

interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUnlockAccount = ({onSuccess, onError}: Input) => {
  const postUnlockAccount = async (payload: PostUnlockAccountFormData) => {
    const res = await axiosClient.post(POST_UNLOCK_ACCOUNT_URL, payload);
    return res.data;
  };

  return useCustomMutation(
      postUnlockAccount,
      {
        onSuccess,
        onError,
      },
      false,
      false
  );
};
